export const buildErrorMessage = (error) => {
  const serverMessage = error?.response?.data?.message;
  let messageText = typeof serverMessage === 'string' && serverMessage.trim() ? serverMessage : null;
  if (!messageText && !error.response) {
    messageText = 'Не удалось связаться с сервером. Проверьте соединение и состояние операции перед повтором.';
  }
  if (!messageText && error.response?.status === 504) {
    messageText = 'Сервер не успел ответить. Операция может продолжаться. Проверьте её состояние перед повтором.';
  }
  messageText ||= 'Не удалось выполнить запрос. Попробуйте ещё раз.';

  if (error.config && error.config.url) {
    messageText += `\nRequest URL: ${error.config.url}`;
  }

  return `${messageText}\nPage URL: ${window.location.pathname}`;
};
